const CopyScheduleShifts = (function () {
  // Data
  let copyShiftParams;
  let employees = [];
  let selectedEmployees;
  let selectAllEmployees = false;
  // DOM
  let consumerSelectList;
  // main popup
  let copyShiftPopup;
  let locationDropdown,
    employeeDropdown,
    publishShiftsCheckbox,
    notifyEmployeesCheckbox,
    includeOpenShiftsCheckbox,
    selectMoreEmployeesBtn;
  let copyFromDateInputs, copyToDateInputs;
  let saveBtn;

  function rgba([r, g, b], a = 1) {
    const mix = channel => Math.round(channel + (255 - channel) * a);
    const newR = mix(r);
    const newG = mix(g);
    const newB = mix(b);

    return `rgb(${newR}, ${newG}, ${newB})`;
  }

  // Presave and save success popups
  function showConflictingShiftsPopup() {
    return new Promise(resolve => {
      const conflictingShiftPopup = POPUP.build({
        id: 'copyShiftConflictingShiftsPopup',
        hideX: true,
      });

      const message = document.createElement('p');
      message.textContent =
        'Some employees could not be scheduled due to conflicts.  Do you want to create open shifts?';
      message.classList.add('message');

      const closeAndResolve = value => {
        conflictingShiftPopup.remove();
        resolve(value);
      };

      const yesBtn = button.build({
        text: 'Yes',
        style: 'secondary',
        type: 'contained',
        callback: () => closeAndResolve(true),
      });
      const noBtn = button.build({
        text: 'No',
        style: 'secondary',
        type: 'outlined',
        callback: () => closeAndResolve(false),
      });

      // Build
      //------------------------------------------
      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');
      buttonWrap.append(yesBtn);
      buttonWrap.append(noBtn);

      conflictingShiftPopup.append(message);
      conflictingShiftPopup.append(buttonWrap);

      POPUP.show(conflictingShiftPopup);
    });
  }
  function showCopiedOpenShiftsPopup(copiedOpenShifts, shiftsPublished) {
    return new Promise(resolve => {
      const openShiftsPopup = POPUP.build({
        id: 'copiedOpenShiftsPopup',
        hideX: true,
      });

      const message = document.createElement('p');
      message.textContent =
        'Shifts successfully copied, the following shifts were created as open shifts.';
      message.classList.add('message');

      const newOpenShiftList = document.createElement('div');
      newOpenShiftList.classList.add('newOpenShiftList');
      copiedOpenShifts.forEach(shift => {
        const shiftDate = shift.ShiftDate.split(' ')[0];
        const startTime = dates.convertFromMilitary(shift.StartTime);
        const endTime = dates.convertFromMilitary(shift.EndTime);

        const shiftEle = document.createElement('div');
        shiftEle.className = 'eventCell';
        shiftEle.setAttribute('data-event-id', shift.ShiftID);
        shiftEle.setAttribute('data-type-id', 3);
        // shiftEle.style.backgroundColor = rgba(shift.colorCode, 0.3);

        const isPublished = shiftsPublished === 'Y' ? true : false;
        const icon = isPublished ? icons.show : icons.eyeClose;
        const pubUnpubIcon = `${
          $.session.schedulingSecurity ? `<p class="pubUnpubIcon">${icon}</p>` : ``
        }`;

        shiftEle.innerHTML = `
          <div>
            <p class="eventTime">
              <span>${shiftDate}</span> <span>${startTime}</span> - <span>${endTime}</span>
            </p>
            <div class="details">
              <p>${shift.EmployeeName}</p>
              <p>${shift.LocationName}</p>
            </div>
          </div>
          ${pubUnpubIcon}
        `;

        newOpenShiftList.appendChild(shiftEle);
      });

      const okBtn = button.build({
        text: 'Ok',
        style: 'secondary',
        type: 'contained',
        callback: () => {
          POPUP.hide(openShiftsPopup);
          resolve();
        },
      });

      // Build
      //------------------------------------------
      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');
      buttonWrap.append(okBtn);

      openShiftsPopup.append(message);
      openShiftsPopup.append(newOpenShiftList);
      openShiftsPopup.append(buttonWrap);

      POPUP.show(openShiftsPopup);
    });
  }

  // Employee Select
  //-----------------------------------------------------------------------
  const debouncedSearch = _UTIL.debounce(e => {
    const searchTerm = e.target.value.toLowerCase();
    const consumers = consumerSelectList.querySelectorAll('p');

    consumers.forEach(consumer => {
      const employerName = consumer.textContent.toLowerCase();
      consumer.style.display =
        !employerName.includes(searchTerm) && !consumer.classList.contains('selected')
          ? 'none'
          : 'block';
    });
  }, 500);

  async function populateEmployeeSection() {
    consumerSelectList.innerHTML = '';

    employees.forEach(employee => {
      const employeeDiv = document.createElement('p');
      employeeDiv.classList.add('employee');
      employeeDiv.textContent = employee.EmployeeName;
      employeeDiv.id = employee.Person_ID;

      if (selectAllEmployees || selectedEmployees.has(employee.Person_ID)) {
        employeeDiv.classList.add('selected');
      }

      consumerSelectList.append(employeeDiv);
    });
  }
  function showEmployeeMutliselectPopup(onSaveCallback) {
    const selectedEmployeesCache = new Map(
      Array.from(selectedEmployees, ([key, value]) => [key, structuredClone(value)]),
    );

    const employeeSelectPopup = POPUP.build({
      id: 'copyShiftSelectEmployeesPopup',
      hideX: true,
      header: 'Select Employees',
    });

    const message = document.createElement('p');
    message.textContent = '*Must select at least one employee before clicking save button.';
    message.classList.add('message');

    const searchInput = input.build({
      type: 'text',
      label: 'Search Employees',
      callbackType: 'keyup',
      className: 'employeeSearchInput',
      callback: debouncedSearch,
    });

    const selectAllBtn = button.build({
      text: 'Select All',
      style: 'secondary',
      type: 'outlined',
      classNames: 'selectAllBtn',
      callback: () => {
        const consumers = consumerSelectList.querySelectorAll('p.employee');

        selectAllEmployees = !selectAllEmployees;

        consumers.forEach(consumer => {
          if (!selectAllEmployees) {
            consumer.classList.remove('selected');
            selectedEmployees.delete(consumer.id);
          } else {
            consumer.classList.add('selected');
            selectedEmployees.set(consumer.id, { id: consumer.id, name: consumer.textContent });
          }
        });

        if (selectedEmployees.size > 0) {
          saveBtn.classList.remove('disabled');
          consuemrSelectedCount.textContent = `${selectedEmployees.size} users selected`;
        } else {
          saveBtn.classList.add('disabled');
          consuemrSelectedCount.textContent = '0 users selected';
        }
      },
    });

    const saveBtn = button.build({
      text: 'Save',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        employeeSelectPopup.remove();
        onSaveCallback(selectedEmployees);
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        employeeSelectPopup.remove();

        selectedEmployees = new Map(
          Array.from(selectedEmployeesCache, ([key, value]) => [key, structuredClone(value)]),
        );
      },
    });

    // Build
    //------------------------------------------
    consumerSelectList = document.createElement('div');
    consumerSelectList.classList.add('consumerSelectList');

    const consuemrSelectedCount = document.createElement('p');
    consuemrSelectedCount.textContent = '0 users selected';
    consuemrSelectedCount.classList.add('consuemrSelectedCount');

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.append(saveBtn);
    buttonWrap.append(cancelBtn);

    employeeSelectPopup.append(message);
    employeeSelectPopup.append(searchInput);
    employeeSelectPopup.append(consumerSelectList);
    employeeSelectPopup.append(selectAllBtn);
    employeeSelectPopup.append(buttonWrap);
    employeeSelectPopup.append(consuemrSelectedCount);

    populateEmployeeSection();

    consumerSelectList.addEventListener('click', ({ target }) => {
      if (!target.classList.contains('employee')) return;

      if (target.classList.contains('selected')) {
        target.classList.remove('selected');
        selectedEmployees.delete(target.id);
      } else {
        target.classList.add('selected');
        selectedEmployees.set(target.id, { id: target.id, name: target.textContent });
      }

      if (selectedEmployees.size > 0) {
        saveBtn.classList.remove('disabled');
        consuemrSelectedCount.textContent = `${selectedEmployees.size} users selected`;
      } else {
        saveBtn.classList.add('disabled');
        consuemrSelectedCount.textContent = '0 users selected';
      }
    });

    POPUP.show(employeeSelectPopup);
  }

  // Main
  //-----------------------------------------------------------------------
  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.EmployeeName.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.EmployeeName.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }
  async function updateEmployeeData() {
    if (
      !copyShiftParams.locationId ||
      copyShiftParams.locationId === 'null' ||
      !copyShiftParams.copyFrom.start ||
      !copyShiftParams.copyFrom.end
    ) {
      employees = [];
      return;
    }

    const resp = (
      await _UTIL.fetchData('getEmployeeDropdownShiftDate', {
        locationId: copyShiftParams.locationId,
        fromDate: dates.formatISO(copyShiftParams.copyFrom.start),
        toDate: dates.formatISO(copyShiftParams.copyFrom.end),
      })
    ).getEmployeeDropdownShiftDateResult;

    employees = resp.sort(sortEmployeeString);

    console.log(employees);
  }
  function populateEmployeeDropdown() {
    // Also, in addition to the current logic being used to populate the Employee dropdown,
    // filter the employee list further to only show employees who have shifts (either published or unpublished)
    // between the "Copy From From Date" and "Copy from To Date" and at the selected location(s).

    const dropdownData = employees.map(d => ({
      value: d.Person_ID,
      text: d.EmployeeName,
    }));

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });
    dropdownData.unshift({
      value: 'none',
      text: '(none)',
    });
    dropdownData.unshift({
      value: 'null',
      text: '',
    });

    dropdown.populate(employeeDropdown, dropdownData, 'null');

    if (
      !copyShiftParams.locationId ||
      copyShiftParams.locationId === 'null' ||
      !copyShiftParams.copyFrom.start ||
      !copyShiftParams.copyFrom.end
    ) {
      input.disableInputField(employeeDropdown);
      dropdown.setValue(employeeDropdown, 'null');
      selectMoreEmployeesBtn.classList.add('disabled');
    } else {
      input.enableInputField(employeeDropdown);
      if (employees.length > 0) selectMoreEmployeesBtn.classList.remove('disabled');
    }
  }
  function populateLocationDropdown() {
    const locations = SchedulingCalendar.getLocations();

    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });
    dropdownData.unshift({
      value: 'null',
      text: '',
    });

    dropdown.populate(locationDropdown, dropdownData, 'null');
  }
  //
  function handleDateChange() {
    if (!copyShiftParams.copyFrom.start || !copyShiftParams.copyFrom.end) {
      input.setValue(copyToDateInputs.start, '');
      input.disableInputField(copyToDateInputs.start);
      return;
    }

    input.enableInputField(copyToDateInputs.start);
    copyToDateInputs.start.classList.toggle('error', !copyShiftParams.copyTo.start);

    // make sure FROM start is before or on FROM end
    const isFromStartBeforeFromEnd = dates.isBefore(
      copyShiftParams.copyFrom.start,
      copyShiftParams.copyFrom.end,
    );
    const isFromStartSameAsBeforeFromEnd = dates.isEqual(
      copyShiftParams.copyFrom.start,
      copyShiftParams.copyFrom.end,
    );
    copyFromDateInputs.end.classList.toggle(
      'error',
      !isFromStartBeforeFromEnd && !isFromStartSameAsBeforeFromEnd,
    );
    fromDatesError.innerHTML =
      !isFromStartBeforeFromEnd && !isFromStartSameAsBeforeFromEnd
        ? `${icons.error} To date can't be after from date.`
        : '';

    if (
      !copyShiftParams.copyTo.start ||
      (!isFromStartBeforeFromEnd && !isFromStartSameAsBeforeFromEnd)
    ) {
      return;
    }

    // make sure FROM start & FROM end are before TO start
    const isFromStartBeforeToStart = dates.isBefore(
      copyShiftParams.copyFrom.start,
      copyShiftParams.copyTo.start,
    );
    const isFromEndBeforeToStart = dates.isBefore(
      copyShiftParams.copyFrom.end,
      copyShiftParams.copyTo.start,
    );
    // make sure both start dates are on same day of week
    const startDatesSameDayOfWeek =
      copyShiftParams.copyFrom.start.getDay() === copyShiftParams.copyTo.start.getDay();

    copyToDateInputs.start.classList.toggle(
      'error',
      !isFromStartBeforeToStart || !fromDatesSameDayOfWeek || !isFromEndBeforeToStart,
    );

    if (!isFromStartBeforeToStart || !isFromEndBeforeToStart) {
      toDatesError.innerHTML = `${icons.error} Copy To start date must come after Copy From end date.`;
      return;
    } else if (!startDatesSameDayOfWeek) {
      toDatesError.innerHTML = `${icons.error} Copy From start date and Copy To start date must fall on the same day of week.`;
      return;
    } else {
      toDatesError.innerHTML = '';
    }

    // set the copy to end(to) date
    const daySpan = dates.differenceInDays(
      copyShiftParams.copyFrom.end,
      copyShiftParams.copyFrom.start,
    );
    copyShiftParams.copyTo.end = dates.addDays(copyShiftParams.copyTo.start, daySpan);
    const ISOdate = dates.formatISO(copyShiftParams.copyTo.end);
    input.setValue(copyToDateInputs.end, ISOdate);
  }
  async function handleFormChange({ target }) {
    switch (target.id) {
      case 'locationDropdown': {
        const selectedOption = target.options[target.selectedIndex];
        copyShiftParams.locationId = selectedOption.value;

        if (!copyShiftParams.locationId || copyShiftParams.locationId === 'null') {
          locationDropdown.classList.add('error');
        } else {
          locationDropdown.classList.remove('error');
        }

        await updateEmployeeData();
        populateEmployeeDropdown();

        break;
      }
      case employeeDropdown: {
        const selectedOption = target.options[target.selectedIndex];
        copyShiftParams.employeeId = selectedOption.value;
        selectedEmployees.set(selectedOption.value, {
          id: selectedOption.value,
          name: selectedOption.textContent,
        });

        employeeDropdown.classList.toggle(
          'error',
          !copyShiftParams.employeeId || copyShiftParams.employeeId === 'null',
        );

        includeOpenShiftsCheckbox.classList.toggle('hidden', copyShiftParams.employeeId !== '%');

        break;
      }
      case 'publishShifts': {
        copyShiftParams.publishShift = target.checked ? 'Y' : 'N';
        break;
      }
      case 'notifyEmployees': {
        copyShiftParams.notifyEmployee = target.checked ? 'Y' : 'N';
        break;
      }
      case 'includeOpenShifts': {
        copyShiftParams.includeOpenShifts = target.checked ? 'Y' : 'N';
        break;
      }
    }

    checkRequiredFields();
  }
  async function handleFormFocusout({ target }) {
    switch (target.id) {
      case 'fromDateStart': {
        copyShiftParams.copyFrom.start = target.value ? new Date(`${target.value} 00:00:00`) : '';
        copyFromDateInputs.start.classList.toggle('error', !copyShiftParams.copyFrom.start);

        handleDateChange();

        await updateEmployeeData();
        populateEmployeeDropdown();

        break;
      }
      case 'fromDateEnd': {
        copyShiftParams.copyFrom.end = target.value ? new Date(`${target.value} 00:00:00`) : '';
        copyFromDateInputs.end.classList.toggle('error', !copyShiftParams.copyFrom.end);

        handleDateChange();

        await updateEmployeeData();
        populateEmployeeDropdown();

        break;
      }
      case 'toDateStart': {
        copyShiftParams.copyTo.start = target.value ? new Date(`${target.value} 00:00:00`) : '';
        copyToDateInputs.start.classList.toggle('error', !copyShiftParams.copyTo.start);
        handleDateChange();
        break;
      }
    }

    checkRequiredFields();
  }
  async function handleFormSubmit() {
    const reqVisualizer = new AsyncRequestVisualizer();
    reqVisualizer.renderTo(_DOM.ACTIONCENTER);

    POPUP.hide(copyShiftPopup);
    reqVisualizer.show('Copying Shifts...');

    const conflictingShifts = (
      await _UTIL.fetchData('getCopyShiftsPreview', {
        locationId: copyShiftParams.locationId,
        employeeId: copyShiftParams.employeeId,
        copyFromFromDate: dates.formatISO(copyShiftParams.copyFrom.start),
        copyFromToDate: dates.formatISO(copyShiftParams.copyFrom.end),
        copyToFromDate: dates.formatISO(copyShiftParams.copyTo.start),
        copyToToDate: dates.formatISO(copyShiftParams.copyTo.end),
        includeOpenShifts: copyShiftParams.includeOpenShifts,
      })
    ).getCopyShiftsPreviewResult;

    let createOpenShiftsFromConflicts;

    if (conflictingShifts && conflictingShifts.length > 0) {
      reqVisualizer.hide();
      createOpenShiftsFromConflicts = await showConflictingShiftsPopup();
    } else {
      createOpenShiftsFromConflicts = false;
    }

    reqVisualizer.show('Copying Shifts...');
    const saveResp = (
      await _UTIL.fetchData('ANYW_Scheduling_CopyShiftsSaveJSON', {
        locationId: copyShiftParams.locationId,
        employeeId: copyShiftParams.employeeId,
        copyFromFromDate: dates.formatISO(copyShiftParams.copyFrom.start),
        copyFromToDate: dates.formatISO(copyShiftParams.copyFrom.end),
        copyToFromDate: dates.formatISO(copyShiftParams.copyTo.start),
        copyToToDate: dates.formatISO(copyShiftParams.copyTo.end),
        includeOpenShifts: copyShiftParams.includeOpenShifts,
        createOpenShifts: createOpenShiftsFromConflicts ? 'Y' : 'N',
        notifyEmployee: copyShiftParams.notifyEmployee,
        publishShifts: copyShiftParams.publishShifts,
      })
    ).saveCopyShiftsSaveResult;

    if (saveResp === 'success' || saveResp) {
      reqVisualizer.hide();

      if (createOpenShiftsFromConflicts) {
        await showCopiedOpenShiftsPopup(conflictingShifts, copyShiftParams.publishShifts);
      }

      await SchedulingCalendar.fetchCalendarEvents();
      SchedulingCalendar.renderCalendarEvents();
    } else {
      reqVisualizer.fullfill('error', 'Error copying shifts', 2000);
    }
  }
  //
  function checkRequiredFields() {
    var hasErrors = [].slice.call(copyShiftPopup.querySelectorAll('.error'));

    if (hasErrors.length === 0) {
      saveBtn.classList.remove('disabled');
    } else {
      saveBtn.classList.add('disabled');
    }
  }
  function showPopup() {
    copyShiftParams = {
      locationId: null,
      employeeId: null,
      copyFrom: {},
      copyTo: {},
      notifyEmployee: 'N',
      publishShifts: 'N',
      includeOpenShifts: 'N',
    };

    selectedEmployees = new Map();

    copyShiftPopup = POPUP.build({
      id: 'copyShiftPopup',
      header: 'Copy Shifts',
    });

    // Inputs
    //------------------------------------------
    locationDropdown = dropdown.build({
      dropdownId: 'locationDropdown',
      label: 'Location',
      style: 'secondary',
    });
    employeeDropdown = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee',
      style: 'secondary',
      classNames: 'disabled',
    });
    publishShiftsCheckbox = input.buildCheckbox({
      text: 'Publish Shifts',
      id: 'publishShifts',
      isChecked: false,
    });
    notifyEmployeesCheckbox = input.buildCheckbox({
      text: 'Notify Employees',
      id: 'notifyEmployees',
      isChecked: false,
    });
    includeOpenShiftsCheckbox = input.buildCheckbox({
      text: 'Include Open Shifts',
      id: 'includeOpenShifts',
      isChecked: false,
    });
    copyFromDateInputs = {
      start: input.build({
        id: 'fromDateStart',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'fromDateEnd',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };
    copyToDateInputs = {
      start: input.build({
        id: 'toDateStart',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'toDateEnd',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };

    // Buttons
    //------------------------------------------
    selectMoreEmployeesBtn = button.build({
      text: 'Select More Employees',
      style: 'secondary',
      callback: () => {
        showEmployeeMutliselectPopup(selectedEmployees => {
          if (selectedEmployees.size === 1) {
            const [selectedEmployee] = selectedEmployees.values();
            copyShiftParams.employeeId = selectedEmployee.id;

            dynamicEmployeeSection.classList.add('hidden');

            employeeDropdown.classList.remove('hidden');
            employeeDropdown.classList.remove('error');
            dropdown.setValue(employeeDropdown, selectedEmployee.id);
          } else {
            copyShiftParams.employeeId = [...selectedEmployees.values()]
              .map(employee => employee.id)
              .join(', ');

            employeeDropdown.classList.add('hidden');
            employeeDropdown.classList.remove('error');

            includeOpenShiftsCheckbox.classList.toggle('hidden', !selectAllEmployees);

            dynamicEmployeeSection.classList.remove('hidden');
            dynamicEmployeeSection.innerHTML = `
              <p>Selected Employees:</p>
              <div>
                <p>${[...selectedEmployees.values()].map(employee => employee.name).join(', ')}</p>
              </div>
            `;
          }

          checkRequiredFields();
        });
      },
    });
    publishShiftsCheckbox = input.buildCheckbox({
      text: 'Publish Shifts',
      id: 'publishShifts',
      isChecked: false,
    });
    notifyEmployeesCheckbox = input.buildCheckbox({
      text: 'Notify Employees',
      id: 'notifyEmployees',
      isChecked: false,
    });
    includeOpenShiftsCheckbox = input.buildCheckbox({
      text: 'Include Open Shifts',
      id: 'includeOpenShifts',
      isChecked: false,
    });
    copyFromDateInputs = {
      start: input.build({
        id: 'fromDateFrom',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'fromDateTo',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };
    copyToDateInputs = {
      start: input.build({
        id: 'toDateFrom',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'toDateTo',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };

    // Buttons
    //------------------------------------------
    saveBtn = button.build({
      text: 'Save',
      style: 'secondary',
      type: 'contained',
      callback: handleFormSubmit,
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        POPUP.hide(pubUnpubPopup);
      },
    });

    // Initial State
    //------------------------------------------
    input.disableInputField(employeeDropdown);
    input.disableInputField(copyToDateInputs.start);
    input.disableInputField(copyToDateInputs.end);

    locationDropdown.classList.add('error');
    employeeDropdown.classList.add('error');
    copyFromDateInputs.start.classList.add('error');
    copyFromDateInputs.end.classList.add('error');

    selectMoreEmployeesBtn.classList.add('disabled');

    includeOpenShiftsCheckbox.classList.add('hidden');

    saveBtn.classList.add('disabled');

    // Build
    //------------------------------------------
    const dynamicEmployeeSection = document.createElement('div');
    dynamicEmployeeSection.classList.add('dynamicEmployeeSection');

    const fromDatesWrap = document.createElement('fieldset');
    fromDatesWrap.classList.add('datesWrap', 'copyFromDates');
    const fromDatesLegend = document.createElement('legend');
    fromDatesLegend.textContent = 'Copy From:';
    fromDatesWrap.append(fromDatesLegend);
    fromDatesWrap.appendChild(copyFromDateInputs.start);
    fromDatesWrap.appendChild(copyFromDateInputs.end);

    const toDatesWrap = document.createElement('fieldset');
    toDatesWrap.classList.add('datesWrap', 'copyToDates');
    const toDatesLegend = document.createElement('legend');
    toDatesLegend.textContent = 'Copy To:';
    toDatesWrap.append(toDatesLegend);
    toDatesWrap.appendChild(copyToDateInputs.start);
    toDatesWrap.appendChild(copyToDateInputs.end);

    const checkboxWrap = document.createElement('div');
    checkboxWrap.classList.add('checkboxWrap');
    checkboxWrap.appendChild(publishShiftsCheckbox);
    checkboxWrap.appendChild(notifyEmployeesCheckbox);
    checkboxWrap.appendChild(includeOpenShiftsCheckbox);

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(saveBtn);
    buttonWrap.appendChild(cancelBtn);

    copyShiftPopup.append(fromDatesWrap);
    copyShiftPopup.append(toDatesWrap);
    copyShiftPopup.append(locationDropdown);
    copyShiftPopup.append(employeeDropdown);
    copyShiftPopup.append(dynamicEmployeeSection);
    copyShiftPopup.append(includeOpenShiftsCheckbox);
    copyShiftPopup.append(selectMoreEmployeesBtn);
    copyShiftPopup.append(checkboxWrap);
    copyShiftPopup.append(buttonWrap);

    populateLocationDropdown();
    populateEmployeeDropdown();

    copyShiftPopup.addEventListener('change', handleFormChange);
    copyShiftPopup.addEventListener('focusout', handleFormFocusout);

    POPUP.show(copyShiftPopup);
  }

  return {
    showPopup,
  };
})();
